/**
 * Utility to disable conflicts with browser extensions and other React instances
 * This helps prevent issues with React hooks and WebSocket connections
 */

// Disable React DevTools to prevent conflicts
if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__.inject = function () {};
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__.isDisabled = true;
  console.log('React DevTools disabled to prevent conflicts');
}

// Disable Service Workers if they exist
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister();
      console.log('Service Worker unregistered to prevent conflicts');
    }
  });
}

// Fix for React 18 concurrent mode conflicts
if (window.React && window.React.version) {
  console.log(`Using React version: ${window.React.version}`);
}

// Prevent extensions from injecting scripts
const originalCreateElement = document.createElement.bind(document);
document.createElement = function (tagName) {
  const element = originalCreateElement(tagName);
  if (tagName.toLowerCase() === 'script') {
    // Add a custom attribute to identify our own scripts
    element.setAttribute('data-app', 'stanley-karaoke');
    
    // Override appendChild to prevent extensions from injecting scripts
    const originalAppendChild = element.appendChild.bind(element);
    element.appendChild = function (child) {
      return originalAppendChild(child);
    };
  }
  return element;
};

// Export a function to check if the environment is clean
export function checkEnvironment() {
  const conflicts = [];
  
  if (window.__REACT_DEVTOOLS_GLOBAL_HOOK__ && !window.__REACT_DEVTOOLS_GLOBAL_HOOK__.isDisabled) {
    conflicts.push('React DevTools is active');
  }
  
  if (window.React && window.React.version && window.React.version !== '18.2.0') {
    conflicts.push(`React version mismatch: ${window.React.version}`);
  }
  
  return {
    isClean: conflicts.length === 0,
    conflicts
  };
}

console.log('Conflict prevention utilities loaded');
